import { DietIdEnum, DietModeType } from '@front-activerse/common-components';

const DIET_TYPE_CLASSIC = {
  id: 21,
  value: DietIdEnum.DIET_ID_CLASSIC,
  optionTitle: 'app.nutritionSettings.dietType.optionClassic.title',
  optionDescription: 'app.nutritionSettings.dietType.optionClassic.description',
  macro: {
    protein: 25,
    fat: 30,
    carbs: 45,
  },
};

const DIET_TYPE_SIMPLE = {
  id: 24,
  value: DietIdEnum.DIET_ID_SIMPLE,
  optionTitle: 'app.nutritionSettings.dietType.optionSimple.title',
  optionDescription: 'app.nutritionSettings.dietType.optionSimple.description',
  macro: {
    protein: 30,
    fat: 33,
    carbs: 37,
  },
};

export const DIET_TYPES_PL = [DIET_TYPE_SIMPLE, DIET_TYPE_CLASSIC];

export const DIET_TYPES_EN = [DIET_TYPE_CLASSIC];

// every diet type the user may already have, regardless of the current language
export const ALL_DIET_TYPES = DIET_TYPES_PL;

export const DIET_MODES = [
  {
    value: DietModeType.slimming,
    optionTitle: 'app.goalSettings.goal.optionWeightLoss.title',
    optionDescription: 'app.goalSettings.goal.optionWeightLoss.description',
  },
  {
    value: DietModeType.stabilization,
    optionTitle: 'app.goalSettings.goal.optionWeightMaintain.title',
    optionDescription: 'app.goalSettings.goal.optionWeightMaintain.description',
  },
  {
    value: DietModeType.gain_muscle_mass,
    optionTitle: 'app.goalSettings.goal.optionBuildMuscle.title',
    optionDescription: 'app.goalSettings.goal.optionBuildMuscle.description',
  },
];

// for i18n-unused
// t('app.goalSettings.dietType.optionClassic.title')
// t('app.goalSettings.dietType.optionClassic.description')
// t('app.goalSettings.dietType.optionVeggie.title')
// t('app.goalSettings.dietType.optionVeggie.description')
// t('app.goalSettings.dietType.optionVegan.title')
// t('app.goalSettings.dietType.optionVegan.description')
// t('app.goalSettings.dietType.optionHighProtein.title')
// t('app.goalSettings.dietType.optionHighProtein.description')
// t('app.goalSettings.dietType.optionGLP1.title')
// t('app.goalSettings.dietType.optionGLP1.description')

// t('app.goalSettings.goal.optionWeightLoss.title')
// t('app.goalSettings.goal.optionWeightLoss.description')
// t('app.goalSettings.goal.optionWeightMaintain.title')
// t('app.goalSettings.goal.optionWeightMaintain.description')
// t('app.goalSettings.goal.optionBuildMuscle.title')
// t('app.goalSettings.goal.optionBuildMuscle.description')
